module.exports = "<div class=modal-header><h3 class=modal-title>{{title}}</h3></div><div class=modal-body><p>{{text}}</p></div><div class=modal-footer><button class=\"btn btn-kt\" ng-click=modalCtrl.close(callback)>OK</button> <button class=\"btn btn-kt\" ng-click=modalCtrl.close()>Cancel</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/modal/confirmation-modal.html
// module id = 507
// module chunks = 0